.textButtonContainer {
    margin-left: 10px;
}